import React from 'react';
import styled from '@emotion/styled';
import { getMQ, breakpoints, SvgImage } from 'src/helpers';
import { taxAuthorityLink, privacyAuthorityLink } from 'src/config';

const TaxLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 13px 0px;

  ${getMQ(breakpoints.m)} {
    margin-top: 25px;
  }
  ${getMQ(breakpoints.l)} {
    margin-top: 20px;
  }
`;

const TaxAuthority = styled.div`
  width: 64px;
  img {
    margin-bottom: 0px;
  }

  ${getMQ(breakpoints.m)} {
    display: flex;
  }
`;

const PrivacyAuthority = styled.div`
  margin-left: 22px;
  width: 222px;
  img {
    margin-bottom: 0px;
  }
`;

interface TaxLinksProps {
  privacyAuthorityIcon: any;
  taxAuthorityIcon: any;
}

const TaxLinks: React.FC<TaxLinksProps> = ({ privacyAuthorityIcon, taxAuthorityIcon }) => {
  return (
    <TaxLinksContainer>
      <a href={privacyAuthorityLink} target="_blank" rel="noreferrer">
        <PrivacyAuthority>
          <SvgImage {...privacyAuthorityIcon} />
        </PrivacyAuthority>
      </a>
      <a href={taxAuthorityLink} target="_blank" rel="noreferrer">
        <TaxAuthority>
          <SvgImage {...taxAuthorityIcon} />
        </TaxAuthority>
      </a>
    </TaxLinksContainer>
  );
};

export default TaxLinks;
